import { useMemo } from 'react';
import { envConfig } from '../../../configs/env';
import { store } from '../../state/store';

export function CustomerAdmin() {
    const isDark = useMemo(() => store.getState().settings.isDark, []);
    return (
        <iframe
            data-auto-sync-theme
            className="w-100 h-100"
            src={envConfig.service + `/customer-admin?isDark=${isDark ? 'true' : 'false'}`}
        />
    );
}
